import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _353adbe6 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _8624b3b2 = () => interopDefault(import('../pages/home/comp_cls.vue' /* webpackChunkName: "pages/home/comp_cls" */))
const _5ed9680e = () => interopDefault(import('../pages/home/cost_credit.vue' /* webpackChunkName: "pages/home/cost_credit" */))
const _a4dff4f2 = () => interopDefault(import('../pages/home/down_files.vue' /* webpackChunkName: "pages/home/down_files" */))
const _ba649982 = () => interopDefault(import('../pages/home/first_prm.vue' /* webpackChunkName: "pages/home/first_prm" */))
const _9a64a5fe = () => interopDefault(import('../pages/home/h2h_footprint.vue' /* webpackChunkName: "pages/home/h2h_footprint" */))
const _2f3ba295 = () => interopDefault(import('../pages/home/home_dash.vue' /* webpackChunkName: "pages/home/home_dash" */))
const _3cd34483 = () => interopDefault(import('../pages/home/left_table.vue' /* webpackChunkName: "pages/home/left_table" */))
const _b747beaa = () => interopDefault(import('../pages/home/map_prm.vue' /* webpackChunkName: "pages/home/map_prm" */))
const _0098f933 = () => interopDefault(import('../pages/home/market_price.vue' /* webpackChunkName: "pages/home/market_price" */))
const _4393035a = () => interopDefault(import('../pages/home/mom_prm.vue' /* webpackChunkName: "pages/home/mom_prm" */))
const _351721d6 = () => interopDefault(import('../pages/home/near_miss.vue' /* webpackChunkName: "pages/home/near_miss" */))
const _22efd1d0 = () => interopDefault(import('../pages/home/prm_comp.vue' /* webpackChunkName: "pages/home/prm_comp" */))
const _0ad26218 = () => interopDefault(import('../pages/home/prm_prod.vue' /* webpackChunkName: "pages/home/prm_prod" */))
const _4eb4a74b = () => interopDefault(import('../pages/home/prod_compar.vue' /* webpackChunkName: "pages/home/prod_compar" */))
const _0ac608d8 = () => interopDefault(import('../pages/home/prod_time.vue' /* webpackChunkName: "pages/home/prod_time" */))
const _0246f794 = () => interopDefault(import('../pages/home/quot_footprint.vue' /* webpackChunkName: "pages/home/quot_footprint" */))
const _76da2cbe = () => interopDefault(import('../pages/home/quot_ot.vue' /* webpackChunkName: "pages/home/quot_ot" */))
const _cd81edbc = () => interopDefault(import('../pages/home/quot_prm.vue' /* webpackChunkName: "pages/home/quot_prm" */))
const _fa2b0f3c = () => interopDefault(import('../pages/home/rnk_ot.vue' /* webpackChunkName: "pages/home/rnk_ot" */))
const _65bb2fdb = () => interopDefault(import('../pages/home/what_if.vue' /* webpackChunkName: "pages/home/what_if" */))
const _54dfd027 = () => interopDefault(import('../pages/motor/comp_cls.vue' /* webpackChunkName: "pages/motor/comp_cls" */))
const _119faf87 = () => interopDefault(import('../pages/motor/down_files.vue' /* webpackChunkName: "pages/motor/down_files" */))
const _0920c93f = () => interopDefault(import('../pages/motor/first_prm.vue' /* webpackChunkName: "pages/motor/first_prm" */))
const _24b479fe = () => interopDefault(import('../pages/motor/h2h_footprint.vue' /* webpackChunkName: "pages/motor/h2h_footprint" */))
const _be3a22fa = () => interopDefault(import('../pages/motor/left_table.vue' /* webpackChunkName: "pages/motor/left_table" */))
const _df0692aa = () => interopDefault(import('../pages/motor/map_prm.vue' /* webpackChunkName: "pages/motor/map_prm" */))
const _c133b99a = () => interopDefault(import('../pages/motor/market_price.vue' /* webpackChunkName: "pages/motor/market_price" */))
const _2fb3995a = () => interopDefault(import('../pages/motor/mom_prm.vue' /* webpackChunkName: "pages/motor/mom_prm" */))
const _5dce4f09 = () => interopDefault(import('../pages/motor/motor_dash.vue' /* webpackChunkName: "pages/motor/motor_dash" */))
const _c92b9054 = () => interopDefault(import('../pages/motor/near_miss.vue' /* webpackChunkName: "pages/motor/near_miss" */))
const _8a3c0860 = () => interopDefault(import('../pages/motor/prm_comp.vue' /* webpackChunkName: "pages/motor/prm_comp" */))
const _ba76e7d0 = () => interopDefault(import('../pages/motor/prm_prod.vue' /* webpackChunkName: "pages/motor/prm_prod" */))
const _6c9a3d4b = () => interopDefault(import('../pages/motor/prod_compar.vue' /* webpackChunkName: "pages/motor/prod_compar" */))
const _71191ed8 = () => interopDefault(import('../pages/motor/prod_time.vue' /* webpackChunkName: "pages/motor/prod_time" */))
const _1f072e36 = () => interopDefault(import('../pages/motor/quot_footprint.vue' /* webpackChunkName: "pages/motor/quot_footprint" */))
const _62fac2be = () => interopDefault(import('../pages/motor/quot_ot.vue' /* webpackChunkName: "pages/motor/quot_ot" */))
const _31313322 = () => interopDefault(import('../pages/motor/quot_prm.vue' /* webpackChunkName: "pages/motor/quot_prm" */))
const _3541bb3c = () => interopDefault(import('../pages/motor/rnk_ot.vue' /* webpackChunkName: "pages/motor/rnk_ot" */))
const _51dbc5db = () => interopDefault(import('../pages/motor/what_if.vue' /* webpackChunkName: "pages/motor/what_if" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _353adbe6,
    name: "login___ie"
  }, {
    path: "/home/comp_cls",
    component: _8624b3b2,
    name: "home-comp_cls___ie"
  }, {
    path: "/home/cost_credit",
    component: _5ed9680e,
    name: "home-cost_credit___ie"
  }, {
    path: "/home/down_files",
    component: _a4dff4f2,
    name: "home-down_files___ie"
  }, {
    path: "/home/first_prm",
    component: _ba649982,
    name: "home-first_prm___ie"
  }, {
    path: "/home/h2h_footprint",
    component: _9a64a5fe,
    name: "home-h2h_footprint___ie"
  }, {
    path: "/home/home_dash",
    component: _2f3ba295,
    name: "home-home_dash___ie"
  }, {
    path: "/home/left_table",
    component: _3cd34483,
    name: "home-left_table___ie"
  }, {
    path: "/home/map_prm",
    component: _b747beaa,
    name: "home-map_prm___ie"
  }, {
    path: "/home/market_price",
    component: _0098f933,
    name: "home-market_price___ie"
  }, {
    path: "/home/mom_prm",
    component: _4393035a,
    name: "home-mom_prm___ie"
  }, {
    path: "/home/near_miss",
    component: _351721d6,
    name: "home-near_miss___ie"
  }, {
    path: "/home/prm_comp",
    component: _22efd1d0,
    name: "home-prm_comp___ie"
  }, {
    path: "/home/prm_prod",
    component: _0ad26218,
    name: "home-prm_prod___ie"
  }, {
    path: "/home/prod_compar",
    component: _4eb4a74b,
    name: "home-prod_compar___ie"
  }, {
    path: "/home/prod_time",
    component: _0ac608d8,
    name: "home-prod_time___ie"
  }, {
    path: "/home/quot_footprint",
    component: _0246f794,
    name: "home-quot_footprint___ie"
  }, {
    path: "/home/quot_ot",
    component: _76da2cbe,
    name: "home-quot_ot___ie"
  }, {
    path: "/home/quot_prm",
    component: _cd81edbc,
    name: "home-quot_prm___ie"
  }, {
    path: "/home/rnk_ot",
    component: _fa2b0f3c,
    name: "home-rnk_ot___ie"
  }, {
    path: "/home/what_if",
    component: _65bb2fdb,
    name: "home-what_if___ie"
  }, {
    path: "/motor/comp_cls",
    component: _54dfd027,
    name: "motor-comp_cls___ie"
  }, {
    path: "/motor/down_files",
    component: _119faf87,
    name: "motor-down_files___ie"
  }, {
    path: "/motor/first_prm",
    component: _0920c93f,
    name: "motor-first_prm___ie"
  }, {
    path: "/motor/h2h_footprint",
    component: _24b479fe,
    name: "motor-h2h_footprint___ie"
  }, {
    path: "/motor/left_table",
    component: _be3a22fa,
    name: "motor-left_table___ie"
  }, {
    path: "/motor/map_prm",
    component: _df0692aa,
    name: "motor-map_prm___ie"
  }, {
    path: "/motor/market_price",
    component: _c133b99a,
    name: "motor-market_price___ie"
  }, {
    path: "/motor/mom_prm",
    component: _2fb3995a,
    name: "motor-mom_prm___ie"
  }, {
    path: "/motor/motor_dash",
    component: _5dce4f09,
    name: "motor-motor_dash___ie"
  }, {
    path: "/motor/near_miss",
    component: _c92b9054,
    name: "motor-near_miss___ie"
  }, {
    path: "/motor/prm_comp",
    component: _8a3c0860,
    name: "motor-prm_comp___ie"
  }, {
    path: "/motor/prm_prod",
    component: _ba76e7d0,
    name: "motor-prm_prod___ie"
  }, {
    path: "/motor/prod_compar",
    component: _6c9a3d4b,
    name: "motor-prod_compar___ie"
  }, {
    path: "/motor/prod_time",
    component: _71191ed8,
    name: "motor-prod_time___ie"
  }, {
    path: "/motor/quot_footprint",
    component: _1f072e36,
    name: "motor-quot_footprint___ie"
  }, {
    path: "/motor/quot_ot",
    component: _62fac2be,
    name: "motor-quot_ot___ie"
  }, {
    path: "/motor/quot_prm",
    component: _31313322,
    name: "motor-quot_prm___ie"
  }, {
    path: "/motor/rnk_ot",
    component: _3541bb3c,
    name: "motor-rnk_ot___ie"
  }, {
    path: "/motor/what_if",
    component: _51dbc5db,
    name: "motor-what_if___ie"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
